export const REFERRAL_HOW_IT_WORKS_CONSTANTS = {
  SECTION_ID: "referral-how-it-works-section",
  SUBTITLE: "THE PROCESS",
  TITLE: "How it works",
  STEPS: [
    {
      STEP_NUMBER: 1,
      TITLE: "Share your link",
      DESCRIPTION:
        "Send it to a friend building a coaching or course business.",
    },
    {
      STEP_NUMBER: 2,
      TITLE: "They subscribe",
      DESCRIPTION: "Your friend gets upto 20% off their first Exly plan.",
    },
    {
      STEP_NUMBER: 3,
      TITLE: "You earn",
      DESCRIPTION:
        "Commission lands in your wallet as soon as their payment clears.",
    },
  ],
  FRIEND_BENEFITS: {
    TITLE: "What your friend gets",
    ITEMS: [
      {
        ID: "friend-discount",
        TEXT: "UPTO 20% off their first Exly subscription",
      },
      {
        ID: "friend-support",
        TEXT: "Free onboarding support from the Exly team",
      },
      {
        ID: "friend-trial",
        TEXT: "7-day free trial of our Premium plan",
      },
    ],
  },
  YOUR_SIDE: {
    SECTION_LABEL: "YOUR SIDE",
    CARDS: [
      {
        ID: "your-side-earn",
        TITLE: "What you earn",
        DESCRIPTION:
          "Commission on every sale. Rate depends on the plan they choose.",
        VARIANT: "primary", // light purple highlight
      },
      {
        ID: "your-side-setup",
        TITLE: "Priority setup",
        DESCRIPTION: "We onboard your referrals for you.",
        VARIANT: "secondary", // light gray / neutral
      },
    ],
  },
};
